const ROUTES = {
  WELCOME: 'home',
  DASHBOARD: 'dashboard',
  SETTINGS: {
    HOME: 'settings',
    CORPORATE: 'corporates',
    CLUSTER: 'clusters',
    TENANT: 'tenants',
    FEE_PERIOD: 'fee-period',
    PMS_CONNECTION: 'pms-connection',
    LOCATIONS: 'location',
    ACCOUNTING: 'accounting',
    ITEM_CODES: 'item-codes',
    ADJUSTMENTS: 'adjustments',
    ADJUSTMENT_UNITS: 'adjustment-units',
    CONTRACTS: 'contracts',
    PROVIDERS: 'providers',
    IGNORED_PROVIDERS: 'ignored-providers',
  },
  RECONCILE: 'reconcile',
  ADJUSTS: 'adjust',
  GUARANTEE: 'guarantee',
  TIMESHEETS: 'time-sheets',
  STATEMENTS: 'statements',
  DOCUMENTS: 'documents',
  REPORTS: 'reports',
  FEE_RUN: 'fee-run',
  FEES: 'fees',
  ADJUSTMENTS: 'adjustments',
  GUARANTEES: 'guarantees',
  BANKTRANSACTIONS: 'bank-transactions',
  BANKSTATEMENTS: 'bank-statements',
  APPROVEDTIMESHEETS: 'approved-time-sheets',
  JOURNALS: 'journals',
  RECONCILIATIONS: 'reconciliations',
  SOURCETRANSACTIONS: 'source-transactions',
  SUPPORT: 'support',
  CLUSTER_FEE_RUN: 'cluster-fee-run',
  CLUSTER_FEES: 'cluster-fees',
  CONTENT: 'help/:type/:section',
};

export default ROUTES;
